// extracted by mini-css-extract-plugin
export var actions = "_lr-d";
export var benefitCard = "_lr-a";
export var benefitIcon = "_lr-b";
export var benefitLabel = "_lr-c";
export var benefits = "_lr-9";
export var bodyText = "_lr-8";
export var closeButton = "_lr-2";
export var content = "_lr-3";
export var eyebrow = "_lr-4";
export var heading = "_lr-5";
export var image = "_lr-f";
export var imagePanel = "_lr-e";
export var modal = "_lr-0";
export var shell = "_lr-1";
export var title = "_lr-6";
export var titleOffer = "_lr-7";